var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"transparent"}},[_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }